import { format, formatDistanceToNow } from 'date-fns'
import { de } from 'date-fns/locale'

/**
 * Format date in de-AT format (DD.MM.YYYY)
 */
export function formatDate(isoDate: string): string {
  return format(new Date(isoDate), 'dd.MM.yyyy', { locale: de })
}

/**
 * Format relative time (e.g., "vor 5 Minuten")
 */
export function formatRelativeTime(isoDate: string): string {
  return formatDistanceToNow(new Date(isoDate), {
    addSuffix: true,
    locale: de,
  })
}
